<section class="error-area ptb-100">
    <div class="container">
        <div class="error-content">
            <p class="error-code" aria-hidden="true">404</p>
            <h1>Page Not Found</h1>
            <p>The page you're looking for may have moved or no longer exists. Try one of these instead:</p>
            <div class="error-actions">
                <a routerLink="/" class="default-btn"><i class="bx bx-home" aria-hidden="true"></i>Back to Home<span></span></a>
                <a routerLink="/services" class="optional-btn"><i class="bx bx-grid-alt" aria-hidden="true"></i>Explore Services<span></span></a>
            </div>
            <p class="error-help">Need help? <a routerLink="/contact">Get in touch</a> and we'll point you in the right direction.</p>
        </div>
    </div>
</section>
